import EmbeddedPDF from "./EmbeddedPDF";

export default EmbeddedPDF;
